import React from "react";

import { postPlatformsConfig } from "./../postPlatforms.config";
import youtubeIconUtils from "../../../../utils/youtube-icon-utils";
import { PlatformLabelBadges } from "../components/PlatformLabelBadges/PlatformLabelBadges";

const PlatformUsage = ({
  platforms,
  field,
  selectedPlatform,
  className = "",
  variant = "default",
}) => {
  const compact = variant === "other-options";
  const types = platforms
    .filter((platform) =>
      postPlatformsConfig[platform.TYPE]?.fields?.includes(field)
    )
    .map((platform) => youtubeIconUtils.resolveYtRedIcon(platform.NAME));

  return (
    <PlatformLabelBadges
      selectedPlatform={selectedPlatform}
      platforms={types}
      className={`${compact ? "h-4 gap-1" : "h-[19px] gap-2"} ${className}`}
      iconClassName={compact ? "size-4" : "size-[15px]"}
    />
  );
};

export default PlatformUsage;
